// extracted by mini-css-extract-plugin
export default {"modalClass":"WJsQqeoVYyQ9nSHXVFrp","table":"KyX1u590JqHxXfikKxfn"};